<template>
  <hm-content title>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="我的模板" name="my">
        <div class="flex mb20">
          <div>
            <el-button type="primary" size="small" @click="addTemp"
              >添加</el-button
            >
          </div>
        </div>
        <div>
          <el-table
            stripe
            border
            :data="myTempMsgList"
            style="width: 100%"
            id="table"
            size="small"
          >
            <el-table-column
              type="index"
              label="序号"
              :index="index => index + (myCurrentPage - 1) * myPageSize + 1"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="模板ID"
            >
              <template slot-scope="scope">
                <div class="flex item-center flex-center">
                  <div class="id-overflow" :title="scope.row.priTmplId">
                    {{ scope.row.templateId }}
                  </div>
                  <input
                    type="text"
                    class="url"
                    :value="scope.row.templateId"
                    ref="activityListUrl"
                  />
                  <el-button
                    type="text"
                    size="small"
                    @click="copyUrl(scope.row)"
                    >复制</el-button
                  >
                </div>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="nickName"
              label="归属公众号"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="title"
              label="标题"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="primaryIndustry"
              label="一级行业"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="deputyIndustry"
              label="二级行业"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="categoryName"
              label="操作"
            >
              <template slot-scope="scope">
                <el-button
                  class="primary"
                  size="small"
                  type="text"
                  @click="toDetails(scope.row)"
                  >详情</el-button
                >
                <el-button
                  class="primary"
                  size="small"
                  type="text"
                  v-if="scope.row.authorizerAppid !== 'wxa4374f8c6493ebaf'"
                  @click="remove(scope.row)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-tab-pane>
      <el-tab-pane label="模板库" name="lib">
        <div class="table mb20 mt20">
          <el-table
            stripe
            border
            :data="groupList"
            style="width: 100%"
            id="table"
            size="small"
          >
            <el-table-column
              type="index"
              label="序号"
              :index="index => index + (currentPage - 1) * pageSize + 1"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="templateIdShort"
              label="ID"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="title"
              show-overflow-tooltip
              label="标题"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="primaryIndustry"
              label="一级行业"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="deputyIndustry"
              label="二级行业"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="categoryName"
              label="操作"
            >
              <template slot-scope="scope">
                <el-button
                  class="primary"
                  size="small"
                  type="text"
                  @click="toDetails(scope.row, 'edit')"
                  >选用</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-tab-pane>
    </el-tabs>
    <div class="hm-pagination mb20">
      <el-pagination
        :page-sizes="[10, 20, 30]"
        background
        :total="groupListTotal"
        @current-change="paging"
        @size-change="handleSizeChange"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="currentPage"
      ></el-pagination>
    </div>
  </hm-content>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      tempType: "",
      myCurrentPage: 1,
      myPageSize: 10,
      currentPage: 1,
      pageSize: 10,
      activeName: "my",
      myTempMsgList: [],
      data: [],
      groupList: [],
      groupListTotal: 0,
      myTotal: 0,
      tempTypeList: []
    };
  },
  computed: {},
  watch: {},
  created() {
    this.queryMyTempMsgList();
  },
  mounted() {},
  methods: {
    addTemp() {
      this.activeName = "lib";
      this.handleClick();
    },
    changeTempType() {
      this.currentPage = 1;
      this.queryList();
    },
    async queryMyTempMsgList() {
      const { result } = await this.$store.dispatch(
        "queryMyOfficialAccountTempMsg",
        {
          pageNo: this.currentPage,
          pageSize: this.pageSize
        }
      );
      const { records, total } = result;
      this.myTempMsgList = records;
      this.groupListTotal = total;
    },
    copyUrl() {
      const input = this.$refs.activityListUrl;
      input.select(); // 选中文本
      document.execCommand("copy");
      this.$message({
        type: "success",
        message: "操作成功"
      });
    },
    async queryList() {
      const { result } = await this.$store.dispatch(
        "queryOfficialAccountTempMsgLib",
        {
          pageNo: this.currentPage,
          pageSize: this.pageSize
        }
      );
      const { records, total } = result;
      this.groupList = records;
      this.groupListTotal = total;
    },
    toDetails(row, type) {
      if (type) {
        this.$router.push({
          name: "TempMsgDetails",
          query: {
            tid: row.tid,
            title: row.title,
            type,
            details: JSON.stringify(row)
          }
        });
      } else {
        this.$router.push({
          name: "TempMsgDetails",
          query: {
            id: row.id,
            details: JSON.stringify(row)
          }
        });
      }
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    handleClick() {
      this.currentPage = 1;
      switch (this.activeName) {
        case "my":
          this.queryMyTempMsgList();
          break;
        case "lib":
          this.queryList();
          break;
        default:
          break;
      }
    },
    async remove(row) {
      const result = await this.$confirm(" 删除本行数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      });
      if (result === "confirm") {
        const { code } = await this.$store.dispatch(
          "removeOfficialAccountTempMsG",
          {
            templateId: row.templateId,
            authorizerAppid: row.authorizerAppid
          }
        );
        if (code === "0") {
          this.$message({
            message: " 操作成功",
            type: "success"
          });
          this.queryMyTempMsgList();
        }
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.id-overflow {
  width: 100px;
  text-overflow: ellipsis;
  overflow: hidden;
  -webkit-line-clamp: 1;
  white-space: nowrap;
}

.url {
  width: 1px;
  opacity: 0;
  border: none;
}
</style>
